export default {
    listagem: {
        titulo_pagina: 'List of Types',
        empty: 'No Value Found for this Type',
        novo: 'Create New Type',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Type Found',
            nome: 'Name',
            codigo: 'Code',
            editar: 'Edit',
            valores: 'Values'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Type',
            editar: 'Edit Type'
        },
        fields: {
            codigo: {
                label: 'Code',
                description: 'Type Code'
            },
            nome: {
                label: 'Name',
                description: 'Type Name'
            },
            status: {
                label: 'Status',
                description: 'Type Active or Inactive Status'
            },
            botao_salvar : 'Save Type'
        },
        create: {
            success: 'Type Created Successfully!',
            error: 'Error Creating Type!'
        },
        update: {
            success: 'Type Successfully Edited!',
            error: 'Error Editing Type!'
        }
    },
    value: {
        form: {
            titulo_pagina: {
                criar: 'Create New Type',
                editar: 'Edit Type'
            },
            fields: {
                codigo: {
                    label: 'Code',
                    description: 'Type Code'
                },
                nome: {
                    label: 'Name',
                    description: 'Type Name'
                },
                description: {
                    label: 'Description',
                    description: 'Description and/or Explanation of the Value'
                },
                status: {
                    label: 'Status',
                    description: 'Type Active or Inactive Status'
                },
                botao_salvar : 'Save Type'
            },
            create: {
                success: 'Type Created Successfully!',
                error: 'Error Creating Type!'
            },
            update: {
                success: 'Type Successfully Edited!',
                error: 'Error Editing Type!'
            }
        }
    }
}
